import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import { router } from './router';
import VueCodeHighlight from 'vue-code-highlight';
import moment from 'moment-timezone'
import VueMeta from 'vue-meta'
import VueSocialauth from 'vue-social-auth'
import axios from 'axios';
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.use(require('vue-moment'), {
    moment,
})

Vue.use(VueSocialauth, {
  providers: {
      google: {
          clientId: '445884629775-l1vcmujhensjrnesgsekduggorniquok.apps.googleusercontent.com',
          client_secret: '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',
          redirectUri: 'http://127.0.0.1:8000/auth/google/callback'
      }
  }
});

import './assets/extra.css';

import './assets/themes/window.css';
import './assets/themes/duotone-sea.css';

import './assets/BeerSlider.css';
import i18n from './i18n'
import './assets/tailwind.css'

import 'flowbite';

Vue.use(vuetify)
Vue.use(VueCodeHighlight)

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
